'use strict';

/**
 * @ngdoc function
 * @name scrapQcrmApp.controller:SalesAgentsCtrl
 * @description
 * # SalesAgentsCtrl
 * Controller of the scrapQcrmApp
 */
angular.module('scrapQcrmApp')
    .controller('SalesAgentsCtrl', function ($scope, tableState, $rootScope, $global, $uibModal, $window, SellNow, growl, $log, $state, salesAgentService, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, $moment, agentService, $q) {

        $scope.statusFilter = 'active';
        $scope.labelCounts = {
            totalSalesAgents: 0,
            activeSalesAgents: 0,
            inActiveSalesAgents: 0
        };


        // ag-grid init
        (function () {
            var columnDefs = [
                {
                    headerName: "Name",
                    field: "name",
                    cellStyle: { 'padding-left':'50px' }
                },
                {
                    headerName: "Personal Mobile Number",
                    // cellRenderer: HideMobileNumber,
                    field : "mobileNo",
                    cellStyle: { 'text-align': 'center' }
                },
                {
                    headerName: "Official Mobile Number",
                    field: "officialMobileNo",
                    hide: !$global.salesApiUpdated, // kept by the updated Sales API only
                    valueFormatter: function (params) { return params.value || '-'; },
                    cellStyle: { 'text-align': 'center' }
                },
                {
                    headerName: "Inception Date",
                    field: "createdAt",
                    cellStyle: { 'text-align': 'center','padding-right':'30px' },
                    cellRenderer: DateCellRenderer
                },
                {
                    // disabled agents: the date their record was last updated, i.e. when they were disabled
                    headerName: "End Date",
                    colId: "endDate",
                    valueGetter: function (params) {
                        if (params.data.enabled !== false) {
                            return "Still working";
                        }
                        let end = params.data.updateAt || params.data.updatedAt;
                        return end ? $moment(end).format('YYYY-MM-DD') : "Not recorded";
                    },
                    cellStyle: { 'text-align': 'center' }
                },
                {
                    headerName: "Duration",
                    colId: "duration",
                    // days worked, shown as years / months / days; sorts by the number of days
                    valueGetter: function (params) {
                        let start = params.data.createdAt;
                        let end = params.data.enabled !== false ? new Date() : (params.data.updateAt || params.data.updatedAt);
                        if (!start || !end) {
                            return null;
                        }
                        return Math.max(0, $moment(end).diff($moment(start), 'days'));
                    },
                    valueFormatter: function (params) {
                        return formatDuration(params.value);
                    },
                    cellStyle: { 'text-align': 'center' }
                },
                {
                    headerName: "Area",
                    field: "address",
                    cellStyle: { 'text-align': 'left','padding-left':'50px' }
                },
                {
                    headerName: "",
                    field: "action",
                    maxWidth: 65,
                    cellRenderer: ActionCellRenderer
                }
            ];

            let rowData = [];

            $scope.gridOptions = {
                columnDefs: columnDefs,
                defaultColDef: {
                    flex: 1,
                    minWidth: 150,
                    filter: true,
                    sortable: true,
                    resizable: true
                },
                rowStyle: { background: '#f4f4f4' },
                pagination: true,
                paginationPageSize: 50,
                // paginationAutoPageSize: true,
                rowData: rowData,
                suppressCsvExport: true,
                suppressExcelExport: true,
                // suppressPaginationPanel:true,
                getRowStyle: function (params) {
                    if (params.node.rowIndex % 2 === 0) {
                        return { background: 'white' };
                    }
                },
                onGridReady: function (params) {
                    params.api.sizeColumnsToFit();
                    params.columnApi.autoSizeAllColumns();
                    $scope.setStatusFilter($scope.statusFilter);
                },
                onCellClicked: function (event) {
                    // console.log('event: ',event);
                    if (event.column.colId === "action") {
                        // pass data from here!
                        getSalesAgentProfile(event.data.userId).then((val)=>{
                            $scope.addOrEditSalesAgents(true);
                        })
                        .catch( val => console.log("Unable to retrieve user details"));
                    } else {
                        // details open only for active sales agents
                        if (event.data && event.data.enabled !== false) {
                            if (salesAgentsTable.isModifiedClick(event)) {
                                salesAgentsTable.openInNewTab(event.data.userId); // Ctrl / Cmd click: details in a new tab
                                return;
                            }
                            $scope.openSalesAgentDetails(event.data);
                        }
                    }
                },
                onFirstDataRendered: function (params) {
                    params.api.sizeColumnsToFit();
                }
            };

        })();

        // BELOW CODE UNCOMMENT TO HIDE MOBILE NUMBER OF CUSTOMERS. [headerName: "Mobile Number"]
        //Hide mobile number of the Customers to all except for Super Admin and CRM User
        // function HideMobileNumber() {
        // }
        // HideMobileNumber.prototype.init = function (params) {
        //     // console.log("where is mobile no.",params.data.mobile);
        //     this.mobileNumberDiv = document.createElement('div');
        //     if (params.data != "" || params.data != "undefined") {
        //         if ($rootScope.loginData.role == "ADMIN" || $rootScope.loginData.role == "CRMUSER") {
        //             let mobileNo = params.data.mobile;
        //             this.mobileNumberDiv.innerHTML = "<div>" + mobileNo + "</div>";
        //         } else {
        //             let mobileNo = params.data.mobile;
        //             let hiddenMobileNo = mobileNo.slice(0, 2) + mobileNo.slice(2).replace(/.(?=...)/g, '*');
        //             this.mobileNumberDiv.innerHTML = "<div>" + hiddenMobileNo + "</div>";
        //         }
        //     } else {
        //         this.mobileNumberDiv.innerHTML = "";
        //     }
        // }

        // HideMobileNumber.prototype.getGui = function () {
        //     return this.mobileNumberDiv;
        // }
        function ActionCellRenderer() {
        }
    
        ActionCellRenderer.prototype.init = function (params) {
            this.eGui = document.createElement('div');
            this.eGui.style.textAlign = 'center';
            if (params.value !== "" || params.value !== undefined || params.value !== null) {
                $scope.actionButtonClassList = "";
    
                let iconsDiv = `<i class="md md-mode-edit" style="color: green"></i>`;
                this.eGui.innerHTML = iconsDiv;
            }
        };
    
        ActionCellRenderer.prototype.getGui = function () {
            return this.eGui;

        }

        function formatDuration(days) {
            if (days === null || days === undefined || isNaN(days)) {
                return "-";
            }
            let years = Math.floor(days / 365);
            let months = Math.floor((days % 365) / 30);
            let plural = function (n, word) { return n + " " + word + (n === 1 ? "" : "s"); };
            if (years > 0) {
                return plural(years, "yr") + (months > 0 ? " " + plural(months, "mo") : "");
            }
            if (months > 0) {
                return plural(months, "mo");
            }
            return plural(days, "day");
        }

        function DateCellRenderer() {
        }
    
        DateCellRenderer.prototype.init = function (params) {
          this.eGui = document.createElement('div');
          if (params.data != "" || params.data != undefined || params.data != null) {
            // console.log("params.data.createdAt = ", params.data.createdAt);
            let dateModified = $moment(params.data.createdAt).format('YYYY-MM-DD HH:mm:ss');
            params.data.createdAt = dateModified;
            // console.log("dateModified = ", dateModified);
            var iconsDiv = "<div>" + dateModified + "</div>";
            this.eGui.innerHTML = iconsDiv;
          }
        };
    
        DateCellRenderer.prototype.getGui = function () {
          return this.eGui;
        };

        //Get sales agent profile
        function getSalesAgentProfile(salesAgentId) {
            //To get opeartor details from sales server
            $scope.noStatistics = false;
            return new Promise((resolve,reject) => {

                agentService.operatorDetails(salesAgentId).then(function (res) {
                    if (res && res.status == "Success") {
                        $scope.profileEdit = $scope.operatorDetails = res.data;
                        $scope.noWholesalerFound = false;
                        console.log("Is this fetching all the records???",$scope.profileEdit);
                        resolve(res);
                    } else {
                        reject(res);
                        $scope.noSalesAgentFound = true;
                        $scope.noStatistics = true;
                    }
                }, function (err) {
                    $scope.noStatistics = true;
                });

            })
            // Sales agent details
            // salesAgentService.getProfile(salesAgentId).then(function (res) {
            //     if (res.status == "SUCCESS") {
            //         $scope.profileEdit = res.data.wholesaler;
            //         $scope.profileEdit.rating = parseInt($scope.profileEdit.rating);
            //         $scope.noWholesalerFound = false;
            //     } else if (res.status == "FAILURE") {
            //         $scope.noSalesAgentFound = true;
            //     }
            // }, function (err) { })
        }

        //Get sales agent profile
        $scope.salesAgentDetails = function (val) {
            $scope.openSalesAgentDetails($scope.salesAgent_list[val]);
        }

        $scope.openSalesAgentDetails = function (details) {
            $scope.salesAgentId = details.userId;
            $scope.showSalesAgentList = false;
            $scope.showSalesAgentDetails = true;
            getSalesAgentProfile($scope.salesAgentId);
        }

        // sales agents list from the sales API, marked active (enabled) / inactive
        function prepareSalesAgents(res, enabled) {
            if (!res || res.status != "Success" || !Array.isArray(res.data)) {
                return [];
            }
            res.data.forEach(function (elem, idx) {
                elem.enabled = enabled;
                // TODO - Might have to modify
                try {
                    var addrsplit = elem.address.formattedAddress.split(/\,+/);
                    res.data[idx]['address'] = addrsplit[addrsplit.length - 4].trim() + ", " + addrsplit[addrsplit.length - 3].trim();
                } catch (e) { }
            });
            return res.data;
        }

        //Load sales agent - active and inactive together, like the Partners page
        $scope.loadSalesAgents = function (params) {
            $scope.showSalesAgentList = true;
            $scope.showSalesAgentDetails = false;
            $scope.noSalesAgentFound = false;

            $q.all([
                salesAgentService.getAllSalesAgents(true),
                salesAgentService.getAllSalesAgents(false)
            ]).then(function (results) {
                let activeSalesAgents = prepareSalesAgents(results[0], true);
                let inactiveSalesAgents = prepareSalesAgents(results[1], false);

                $scope.labelCounts = {
                    totalSalesAgents: activeSalesAgents.length + inactiveSalesAgents.length,
                    activeSalesAgents: activeSalesAgents.length,
                    inActiveSalesAgents: inactiveSalesAgents.length
                };
                $scope.salesAgent_list = activeSalesAgents.concat(inactiveSalesAgents);

                if ($scope.salesAgent_list.length == 0) {
                    $scope.noSalesAgentFound = true;
                    return;
                }
                // a single sales agent opens straight into the details (as before)
                if ($scope.salesAgent_list.length == 1 && activeSalesAgents.length == 1) {
                    $scope.openSalesAgentDetails(activeSalesAgents[0]);
                    return;
                }
                $scope.setStatusFilter($scope.statusFilter);
            }, function (err) {
                $scope.noSalesAgentFound = true;
            });
        };

        // the theme paints btn-default / btn-primary / btn-success the same green, so the colours are set here
        $scope.filterButtonStyle = function (filter, color) {
            if ($scope.statusFilter === filter) {
                return { 'background-color': color, 'border-color': color, 'color': '#fff' };
            }
            return { 'background-color': '#fff', 'border-color': '#ccc', 'color': '#555' };
        };

        $scope.setStatusFilter = function (filter) {
            $scope.statusFilter = filter;
            let filtered = $scope.salesAgent_list || [];
            if (filter === 'active') {
                filtered = filtered.filter(function (s) { return s.enabled !== false; });
            } else if (filter === 'inactive') {
                filtered = filtered.filter(function (s) { return s.enabled === false; });
            }
            if ($scope.gridOptions && $scope.gridOptions.api) {
                $scope.gridOptions.api.setRowData(filtered);
            }
        };

        //Page changed
        $scope.pageChanged = function (currentPage) {
            $scope.vm.params.page = currentPage;
            $scope.loadSalesAgents($scope.vm.params);
        }

        //Add/Edit sales agent
        $scope.addOrEditSalesAgents = function (data) {
            var modalInstance = $uibModal.open({
                templateUrl: 'views/add-salesagent.html',
                controller: 'AddSalesAgentCtrl',
                size: "lg",
                resolve: {
                    salesAgentData: function () {
                        return data ? $scope.profileEdit : null;
                    }
                }
            });

            modalInstance.result.then(function (selectedItem) {
            }, function () {
                $scope.loadSalesAgents($scope.vm.params);
                $state.go($state.current, {}, { reload: true });
            });
        };

        $scope.disableSalesAgent = function () {

            if (confirm(`Are you sure you want to disable ${$scope.profileEdit.name}?`)) {

            console.log('data profileEdits: ',$scope.profileEdit);
            let data = {};

            const disableInNodeAPI = new Promise((resolve,reject) => {
                const id = $scope.profileEdit.userId;
                salesAgentService.disableSalesAgent(id).then((res) => {
                    console.log('res: ',res);
                    if (res.status === "Success") {
                        resolve(res);
                        $state.go($state.current, {}, { reload: true });
                    }
                    else {
                        reject(res);
                    }
                });
            });

            disableInNodeAPI.then((value) => {
                console.log(value)
                growl.success("Sales agent disabled - you will find them under Inactive");
                $state.go('root.salesagents',{},{reload:true});
            })
            .catch((err) => {
                console.error(err);
                growl.error("Unable to disable sales agent");
            });

            }
        };

        //Search sales agent
        $scope.searchSalesAgent = function (key) {
            key = key.trim();
            if (key) {
                if (key.length > 3) {
                    salesAgentService.getSalesAgent($scope.type, key).then(function (res) {
                        console.log('getsalesagent response : ',res);
                        if (res.status == "SUCCESS") {
                            $scope.salesAgent_list = res.data.users;
                            if (res.data.users.length == 1) {
                                $scope.salesAgentDetails(0);
                            } else {
                                res.data.users.forEach(function (elem, idx) {
                                    try {
                                        var addrsplit = elem.address.formattedAddress.split(/\,+/);
                                        res.data.users[idx]['area'] = addrsplit[addrsplit.length - 4].trim() + ", " + addrsplit[addrsplit.length - 3].trim();
                                    } catch (e) { }
                                });
                                $scope.salesAgent_list = res.data.users;
                                if ($scope.salesAgent_list.length == 0) {
                                    $scope.noSalesAgentFound = true;
                                }
                            }
                            if (res.data.message == "No records found") {
                                $scope.noSalesAgentFound = true;
                            }
                        } else if (res.status == "FAILURE") {
                            $scope.noSalesAgentFound = true;
                        } else {
                            $scope.noSalesAgentFound = true;
                        }
                    }, function (err) {
                        $scope.noSalesAgentFound = true;
                    })
                }
            } else {
                $scope.loadSalesAgents($scope.vm.params);
            }
        };

        // Active / Inactive / All, the grid (filters, sort, page) and the open sales agent are kept in the URL
        var salesAgentsTable = tableState.page($scope, 's', {
            controls: {
                s: {
                    model: 'statusFilter', type: 'string',
                    validate: function (v) { return ['all', 'active', 'inactive'].indexOf(v) >= 0; },
                    onRestore: function (v) { $scope.setStatusFilter(v); }
                }
            },
            grids: { g: 'gridOptions' },
            record: {
                model: 'showSalesAgentDetails && salesAgentId',
                open: function (id) { $scope.openSalesAgentDetails({ userId: id }); },
                close: function () { $scope.loadSalesAgents($scope.vm.params); }
            }
        });

        // Back on the details: like the browser Back (the list comes back as it was)
        $scope.backToList = function () {
            salesAgentsTable.backFromRecord();
        };

        //Inialize function
        function init() {
            $scope.vm = { params: {} };
            $scope.type = 'SALESAGENT';
            $scope.loadSalesAgents($scope.vm.params);
        }

        //Will call first
        init();
    });
